import { DetectorAction, CommonAction } from 'Actions/index';
import { DetectorActionTypes, CommonActionTypes } from 'Actions/ActionTypes/index';
import { IDetectors } from 'Store/Tss/IDetectors';
import Util from 'Util/index';

const initialState: IDetectors = {};

export const detectors = (state: IDetectors = initialState, action: DetectorAction | CommonAction) => {

    let newState: IDetectors;

    switch (action.type) {
        case DetectorActionTypes.AddDetectors:
        case DetectorActionTypes.ModifyDetectors:
            newState = { ...state };
            action.detectors.forEach(detector => {
                newState[Util.IdToString(detector.id!)] = detector;
            });
            break;
        case DetectorActionTypes.DeleteDetectors:
            newState = { ...state };
            action.ids.forEach(id => delete newState[Util.IdToString(id!)]);
            break;
        case CommonActionTypes.ClearStore:
            newState = initialState;
            break;
        default:
            newState = state;
    }

    return newState;
}